import type { Service } from '@/types/booking';

/** True when a professional offers the service, as "Any professional" needs. */
export function hasBarberAssignment(service: Service): boolean {
  return (service.assignments ?? []).some(
    (assignment) => assignment.assignmentType === 'barber',
  );
}
